'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _iBem.decl)({
    block: 'service-icon',
    render: function render() {
        var block = this.block,
            _props = this.props,
            service = _props.service,
            view = _props.view,
            size = _props.size,
            children = _props.children;

        if (children) {
            return this.__base.apply(this, arguments);
        }
        return _react2.default.createElement(_iBem2.default, { block: block, elem: service, mods: _defineProperty({}, view, size) });
    }
}, {
    propTypes: {
        service: _propTypes2.default.string,
        view: _propTypes2.default.string,
        size: _propTypes2.default.string
    }
});